// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "ea2d184";
